import { Navigate } from "react-router";

import { HubStaffPageGate, HubSection } from "./RecordPages.js";

export function ManageHubPage({ id }: { id: string }) {
	return (
		<HubStaffPageGate>
			<HubSection id={id} />
		</HubStaffPageGate>
	);
}

export function ManagePhoneNumbers() {
	return (
		<HubStaffPageGate>
			<HubSection id="phones" />
		</HubStaffPageGate>
	);
}

export function ManagePlaceholder({ title, detail }: { title: string; detail?: string }) {
	return (
		<div className="card">
			<h2>{title}</h2>
			<p className="sub">{detail ?? "This section is not set up in the control panel yet."}</p>
		</div>
	);
}

export function ManageEmailHome() {
	return <Navigate to="mailboxes" replace />;
}

export function ManagePhoneHome() {
	return <Navigate to="numbers" replace />;
}
